<template>
    <div>
        <b-field class="commonrules-grp" label="The class of service  is "></b-field>
        <div class="airclasscheckbox">
            <b-checkbox type="is-teal" @input="classOfServices" native-value="Y" v-model="classOfServiceArr">
                <p>Economy</p>
            </b-checkbox>
            <b-checkbox type="is-teal" @input="classOfServices" native-value="M" v-model="classOfServiceArr">
                <p>Standard Economy</p>
            </b-checkbox>
            <b-checkbox type="is-teal" @input="classOfServices" native-value="W" v-model="classOfServiceArr">
                <p>Premium Economy</p>
            </b-checkbox>
            <b-checkbox type="is-teal" @input="classOfServices" native-value="C" v-model="classOfServiceArr">
                <p>Business</p>
            </b-checkbox>
            <b-checkbox type="is-teal" @input="classOfServices" native-value="F" v-model="classOfServiceArr">
                <p>First</p>
            </b-checkbox>
        </div>
    </div>
</template>
<script>
import { watch } from 'fs';

export default {
    name: "AirClassOfService",
    props: { classOfSer: null },
    data() {
        return {
            classOfServiceArr: this.classOfSer ? this.classOfSer : []
        }
    },
    mounted() {

    },
    methods: {
        classOfServices(val) {
            //  this.classOfService.push(val.key);
            // this.$emit('classOfServices',this.$data.classOfService);
            this.$emit('classOfServices', this.classOfServiceArr);
        }
    }
}
</script>
<style>
.airclasscheckbox{
    padding-top:10px;
}
</style>